import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import NavBar from "../../components/navbar/navbar.component";
import SideBar from "../../components/sidebar/sidebar.component";
import { cancelShipment, getShipments } from "../../state/actions";
import { getCustomers } from "../../state/actions/rider.actions";

const CustomerShipments = () => {
  const dispatch = useDispatch();
  const shipments = useSelector((state) => state.orders.shipments);
  const isLoading = useSelector((state) => state.orders.status);
  const [customer, setCustomer] = useState();
  const [options, setOptions] = useState([]);
  const [waybillSearch, setWaybillSearch] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  const getSearchValues = () => {
    const start = new Date();
    start.setMonth(start.getMonth() - 3);

    return {
      id: customer ? customer.value : "",
      start: start.toISOString(),
      end: new Date().toISOString(),
    };
  };

  const fetchShipments = () => {
    dispatch(getShipments(getSearchValues()));
  };

  const handleCustomerChange = (selectedCustomer) => {
    setCustomer(selectedCustomer);
    setHasSearched(false);
  };

  const handleSearchValues = (event) => {
    event.preventDefault();

    if (!customer) {
      alert("Please select a customer");
      return;
    }

    setHasSearched(true);
    fetchShipments();
  };

  const handleCancelShipment = async (shipment) => {
    const shouldCancel = window.confirm(
      `Are you sure you want to cancel shipment ${shipment.waybillNumber}?`
    );

    if (!shouldCancel) {
      return;
    }

    try {
      await dispatch(cancelShipment(shipment.waybillNumber));
      alert("Shipment cancelled successfully");
      fetchShipments();
    } catch (error) {
      console.log("Unable to cancel shipment", error);
    }
  };

  const filteredShipments = shipments.filter((shipment) =>
    shipment.waybillNumber
      ?.toLowerCase()
      .includes(waybillSearch.toLowerCase())
  );

  useEffect(() => {
    dispatch(getCustomers()).then((customers) => {
      const customerOptions = customers
        .sort((a, b) => a.firstName?.localeCompare(b.firstName || ""))
        .map((customer) => ({
          label: customer.companyName
            ? `${customer.firstName} ${customer.lastName} ( ${customer.companyName} )`
            : `${customer.firstName} ${customer.lastName}`,
          value: customer.id,
        }));

      setOptions(customerOptions);
    });
  }, [dispatch]);

  return (
    <>
      <NavBar />
      <SideBar />

      <div className="content-page">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between">
                  <div className="header-title">
                    <h4 className="card-title">Customer Shipments</h4>
                  </div>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSearchValues}>
                    <div className="row">
                      <div className="col-md-8">
                        <div className="d-flex mb-2">
                          <p
                            style={{ fontSize: "14px" }}
                            className="col-5 col-md-4 col-lg-3 mb-0"
                          >
                            Select Customer:
                          </p>
                          <Select
                            className="col-7 col-md-8 col-lg-9 px-0"
                            options={options}
                            value={customer}
                            isSearchable={true}
                            isClearable={true}
                            onChange={handleCustomerChange}
                          />
                        </div>
                      </div>
                      <div className="col-md-4 d-flex justify-content-end justify-content-md-start">
                        <button type="submit" className="btn btn-sm btn-primary">
                          Submit
                        </button>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-8">
                        <div className="d-flex mb-2">
                          <p
                            style={{ fontSize: "14px" }}
                            className="col-5 col-md-4 col-lg-3 mb-0"
                          >
                            Search Waybill:
                          </p>
                          <input
                            type="text"
                            className="form-control form-control-sm col-7 col-md-8 col-lg-9"
                            value={waybillSearch}
                            onChange={(event) =>
                              setWaybillSearch(event.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </form>

                  {hasSearched && isLoading === "loading" ? (
                    <div className="text-center mt-4">
                      <div className="spinner-border text-danger" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                      <p className="small">Fetching Shipments...</p>
                    </div>
                  ) : hasSearched && filteredShipments.length > 0 ? (
                    <div className="table-responsive">
                      <Table aria-label="customer shipments table">
                        <TableHead>
                          <TableRow>
                            <TableCell>Order Number</TableCell>
                            <TableCell>Origin</TableCell>
                            <TableCell>Destination</TableCell>
                            <TableCell>Content</TableCell>
                            <TableCell>Weight</TableCell>
                            <TableCell>Quantity</TableCell>
                            <TableCell>Status</TableCell>
                            <TableCell>Actions</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {filteredShipments.map((shipment) => (
                            <TableRow hover tabIndex={-1} key={shipment.id}>
                              <TableCell>{shipment.waybillNumber}</TableCell>
                              <TableCell>{shipment.origin?.name}</TableCell>
                              <TableCell>{shipment.city?.name}</TableCell>
                              <TableCell>{shipment.contentDescription}</TableCell>
                              <TableCell>{`${shipment.weight}kg`}</TableCell>
                              <TableCell>{shipment.unit}</TableCell>
                              <TableCell>{shipment.status === 52 ? "Cancelled" : (shipment.status === 20) ? "Delivered" : (shipment.status === 0) ? "New" : "In-Procress"}</TableCell>
                              <TableCell style={{ whiteSpace: "nowrap" }}>
                                <Link
                                  className="btn btn-sm btn-primary mr-1"
                                  to={`/customer-shipments/${shipment.id}`}
                                  state={{ shipment }}
                                >
                                  Edit
                                </Link>
                                { shipment.status === 0 &&
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => handleCancelShipment(shipment)}
                                >
                                  Cancel
                                </button>}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  ) : hasSearched ? (
                    <div className="text-center mx-auto mt-4">
                      <p className="text-Center">No Shipment Available Currently</p>
                    </div>
                  ) : (
                    <div className="text-center mx-auto mt-4">
                      <p className="text-Center">Select a customer to view shipments</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CustomerShipments;
